import {
  LivretEleveDomaine,
  LivretEleveMatiere,
} from '@teetsh/app/src/containers/Livrets/types/livret';

export function removeCompetence(
  matiere: LivretEleveMatiere,
  competenceId: string,
  domaine?: LivretEleveDomaine,
): LivretEleveMatiere {
  if (domaine) {
    const domaines = matiere.domaines.map(oldDomaine => {
      if (domaine && oldDomaine.id === domaine.id) {
        const competences = oldDomaine.competences.filter(
          c => c.id !== competenceId,
        );
        return {
          ...oldDomaine,
          competences,
        };
      }
      return oldDomaine;
    });
    return {
      ...matiere,
      domaines,
    };
  }
  const competences = (matiere?.competences || []).filter(
    c => c.id !== competenceId,
  );
  return {
    ...matiere,
    competences,
  };
}
